var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"placement":"right","width":"200","trigger":"hover"}},[_c('el-button',{attrs:{"slot":"reference","plain":"","icon":"el-icon-more","size":"small"},slot:"reference"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }